module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="farm-branding-region"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/farm-branding/farm-branding.html
 ** module id = 213
 ** module chunks = 1 23 27 28 39 42 62 76 81 89 136
 **/